import { TypeVoie } from './TypeVoie';

export class TypeLieu {

  public voie: TypeVoie;

  public ville: string;

  public cp: string;

  constructor() {
    this.voie = new TypeVoie();
    this.ville = '';
    this.cp = '';

  }
}
